const nextIcon1 = '<img src="https://cdn.shopify.com/s/files/1/0610/2401/0326/files/arrow-slider-l.svg?v=1729072252" alt="left">';
const prevIcon1 = '<img src="https://cdn.shopify.com/s/files/1/0610/2401/0326/files/arrow-slider-r.svg?v=1729072252" alt="right">';

jQuery('.select_card-1 .owl-carousel').owlCarousel({
loop: true,
center: true,
margin: 40,
navText: [nextIcon1, prevIcon1],
nav: true,
dots: false,
slidesToShow: 2.5,
dotsEach:true,
autoplayTimeout: 5000, // duration after slide move
autoplay: false,
autoplaySpeed: 1000,
fluidSpeed: true,
smartSpeed: 1000,
URLhashListener: true,
autoHeight: true,
startPosition: 'URLHash',
responsive: {
  0: {
    items: 1.1,
  },
  375: {
    items: 1.2,
  },
  576: {
    items: 1.2,
  },
992: {
  items: 1.5,
},
1200: {
  items: 1.8,
},
1600: {
  items: 1.9,
},
1900: {
  items: 2.3
},
2000: {
  items: 2.6
}
}
});



$('.custom-scroll-newsletter').on('click', function (e) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $('.news_letter').offset().top
      }, 1000); // 800ms smooth scroll
    });
    
    $('.custom-scroll-mobile-newsletter').on('click', function (e) {
      e.preventDefault();
$('.header--mobile-center .header__icon.header__icon--menu').trigger('click')
      $('html, body').animate({
        scrollTop: $('.news_letter .top-text').offset().top
      }, 1000); // 800ms smooth scroll
    });

$(document).ready(function () {
  if (window.location.hash === "#newslatter") {
    var $target = $(".news_letter");

    if ($target.length) {
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: $target.offset().top
        }, 800); // smooth scroll speed
      }, 300); // small delay for page load
    }
  }
});